"use strict";
/**
 * Order Display UI
 * Handles order details and results display
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.displayOrderDetails = displayOrderDetails;
exports.clearOrderDetails = clearOrderDetails;
/**
 * Escape HTML to prevent XSS
 */
function escapeHtml(text) {
    const map = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#039;",
    };
    return text.replace(/[&<>"']/g, (char) => map[char]);
}
/**
 * Display order details in result view
 */
function displayOrderDetails(order) {
    const detailsContainer = document.getElementById("order-details");
    if (!detailsContainer)
        return;
    detailsContainer.innerHTML = `
    <div class="order-detail-row">
      <span class="label">Order ID:</span>
      <span class="value">${escapeHtml(order.id)}</span>
    </div>
    <div class="order-detail-row">
      <span class="label">Side:</span>
      <span class="value">${escapeHtml(order.side)}</span>
    </div>
    <div class="order-detail-row">
      <span class="label">Quantity:</span>
      <span class="value">${order.quantity} shares</span>
    </div>
    <div class="order-detail-row">
      <span class="label">Filled:</span>
      <span class="value">${order.filled} shares</span>
    </div>
    <div class="order-detail-row">
      <span class="label">Avg Price:</span>
      <span class="value">${escapeHtml(order.averagePrice)}</span>
    </div>
    <div class="order-detail-row">
      <span class="label">Total Cost:</span>
      <span class="value">${escapeHtml(order.totalCost)}</span>
    </div>
    <div class="order-detail-row">
      <span class="label">Status:</span>
      <span class="value status-${order.status.toLowerCase()}">${escapeHtml(order.status)}</span>
    </div>
  `;
}
/**
 * Clear order details display
 */
function clearOrderDetails() {
    const detailsContainer = document.getElementById("order-details");
    if (detailsContainer) {
        detailsContainer.innerHTML = "";
    }
}
